<template>
<!-- ACTUALLY FOR SCHOOLS ATTATCHED TO ORG I JUST MISNAMED :( )-->
  <div class="student-table-wrapper">
    <div class="student-table-container">
      <table class="student-table">
        <thead>
          <tr>
            <th @click="toggleSort('id')">ID</th>
            <th @click="toggleSort('name')">Name</th>
            <th @click="toggleSort('updated')">Updated</th>
            <th @click="toggleSort('type')">Type</th>
            <th @click="toggleSort('compliance')">Behind in Compliance</th>
          </tr>
        </thead>
        <tbody>
            <tr
              v-for="schools in paginatedStudents"
              :key="schools.sub_org_id"
          >
              <td
                  class="clickable-name"
                  @click="goToSchool(schools.sub_org_id)"
              >
                  {{ schools.sub_org_id }}
              </td>

              <td>
                  {{ schools.orgName }}
              </td>

              <td>
                  {{formatDate(schools.lastUpdatedAt )}}
              </td>

              <td>
                  {{ schools.type }}
              </td>

              <td>
                  {{ schools.compliance }}
              </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="pagination-wrapper">
      <div class="pagination">
        <button @click="prevPage" :disabled="currentPage === 1">Previous</button>

        <button
          v-for="page in paginationRange"
          :key="page"
          @click="page !== '...' && goToPage(page)"
          :disabled="page === '...'"
          :class="{ active: currentPage === page }"
        >
          {{ page }}
        </button>

        <button @click="nextPage" :disabled="currentPage === totalPages">
          Next
        </button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "OrganizationSpecialistTable",
  data() {
    return {
      students: [], // Filled from API
      currentPage: 1,
      studentsPerPage: 8,
      hideInactive: false,
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.students.length / this.studentsPerPage);
    },
    paginatedStudents() {
      const start = (this.currentPage - 1) * this.studentsPerPage;
      const end = start + this.studentsPerPage;
      return this.students.slice(start, end);
    },
    paginationRange() {
      const total = this.totalPages;
      const current = this.currentPage;
      const delta = 2;
      const range = [];

      let left = current - delta;
      let right = current + delta;

      if (left < 1) {
        left = 1;
        right = Math.min(total, left + delta * 2);
      }
      if (right > total) {
        right = total;
        left = Math.max(1, right - delta * 2);
      }

      for (let i = left; i <= right; i++) {
        range.push(i);
      }

      if (range[0] > 1) {
        range.unshift(1);
        if (range[1] > 2) range.splice(1, 0, "...");
      }
      if (range[range.length - 1] < total) {
        range.push(total);
        if (range[range.length - 2] < total - 1)
          range.splice(range.length - 1, 0, "...");
      }

      return range;
    },
  },
  methods: {
    formatDate(date) {
      return new Date(date).toLocaleDateString();
    },
    goToPage(page) {
      this.currentPage = page;
    },
    prevPage() {
      if (this.currentPage > 1) this.currentPage--;
    },
    nextPage() {
      if (this.currentPage < this.totalPages) this.currentPage++;
    },
    toggleSort(field){

      if (this.clickSort === field + "ASC") {
          this.clickSort = field + "DESC"
      } else {
          this.clickSort = field + "ASC"
      }

      this.fetchSearchFilter()
    },
    goToSchool(orgID) {
      this.$router.push(`/schools/${orgID}`);
    },
    async fetchSearchFilter() {
      console.log("Fetching students...");

      try {
        const baseUrl = process.env.VUE_APP_REVERSE_PROXY_ENDPOINT || "http://localhost:8081";

        // get specialist_id from cookie
        const authResp = await fetch(`${baseUrl}/api/auth/get-access-cookie-data`, {
          credentials: "include",
        });
        if (!authResp.ok) throw new Error("Failed to fetch auth cookie data");
        const authData = await authResp.json();
        const ID = authData.id;

        const params = new URLSearchParams();
                if (this.search) params.append("search", this.search);
                if (this.sortFilter) params.append("sortFilter", this.sortFilter);
                if (this.clickSort) params.append("clickSort", this.clickSort);

                const response = await fetch(
                `${baseUrl}/api/organization/user/${ID}/get-school?${params}`,
                {
                    credentials: "include",
                }
                );    

        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        const data = await response.json();

        // map data into schools array
        this.students = data.schools.map((s) => ({
          sub_org_id: s.sub_org_id,
          orgName: s.orgName,
          lastUpdatedAt: s.lastUpdateAt,
          type: s.type,
          compliance: s.compliance,
        }));

        console.log("Mapped schools:", this.students);

        console.log("Mapped students:", this.students);
      } catch (err) {
        console.error("Error fetching students:", err);
      }
    }
  },
  mounted() {
    this.fetchSearchFilter();
  },
  props: {
  search: String,
  sortFilter: String,
  clickSort: String
 },
  watch: {
    search: "fetchSearchFilter",   
    sortFilter: "fetchSearchFilter", 
    clickSort: "fetchSearchFilter"
  },
};
</script>

<style scoped lang="scss">
.student-table-container {
  padding: 1rem;
  margin-top: 0;
  padding-top: 0;
}

.student-table-container .button-wrapper {
  display: flex;
  justify-content: flex-end;
}

.student-table-container button {
  display: flex;
  justify-content: flex-end;
  //margin-bottom: 1rem;
  padding: 0.25rem 0.5rem;
  color: #98a2b3;
  border: none;
  cursor: pointer;
}

.student-table-container button:hover {
  color: #9D5f0E;
  font-weight: 600;
}

.student-table-container button.active {
  color: #9D5f0E;
  font-weight: 600;
}
.student-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 0;

  th,
  td {
    padding: 0.75rem;
    border-bottom: 1px solid #ccc;  
    text-align: center;
  }

  thead {
    position: relative; 
    font-size: 14px;
    color: #98a2b3;

    &::after {
        content: '';
        position: absolute;
        bottom: 0;      
        left: 50%;      
        transform: translateX(-50%);
        width: 1200px; 
        border-bottom: 1px solid #ccc;
        pointer-events: none;  
    }

    th {
        border-bottom: none;  
        font-weight: 400;
    }
  }

  tbody {
    font-weight: 450;
  }

  .active {
    color: green;
    border: 2px solid green; 
    border-radius: 0.5rem;
    padding: 0.4rem 0.8rem;
    display: inline-block;
    background-color: #a6e7d8;
  }

  .inactive {
    color: red;
    border: 2px solid red; 
    border-radius: 0.5rem;
    padding: 0.4rem 0.8rem; 
    display: inline-block;
    background-color: #ffc5c5;
  }
}

.pagination-wrapper{
  display: flex;
  justify-content: flex-end;
  padding-bottom: 10px;
  margin-bottom: 10px;
}

.pagination {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 10px;
}

.pagination button {
  padding: 5px 10px;
  border: 1px solid #ccc;
  background: #fff;
  cursor: pointer;
}

.pagination button.active {
  background: #f97316; /* orange */
  color: white;
  border-color: #f97316;
}

.pagination button:disabled {
  opacity: 0.5;
  cursor: default;
}

</style>
